import { render, staticRenderFns } from "./registerCollect.vue?vue&type=template&id=6ad5ba5c&scoped=true&"
import script from "./registerCollect.vue?vue&type=script&lang=js&"
export * from "./registerCollect.vue?vue&type=script&lang=js&"
import style0 from "./registerCollect.vue?vue&type=style&index=0&id=6ad5ba5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad5ba5c",
  null
  
)

export default component.exports